export const getRiskGradeOffset = (risk, grades, tenantTypeId, hasTabellaB = true) => {
    const firstLowerBound = Math.min(...grades.map((grade) => Number(grade.valoreRischioDa)));
    const score = tenantTypeId === 3 && !hasTabellaB ? firstLowerBound : risk;
    const grade = grades.find((item) =>
        (tenantTypeId === 3 ? score >= Number(item.valoreRischioDa) :
        score > Number(item.valoreRischioDa) ||
        (score === firstLowerBound && Number(item.valoreRischioDa) === firstLowerBound)) &&
        score <= Number(item.valoreRischioA)
    );
    const offset = grade?.offset == null ? null : Number(grade.offset);
    return Number.isFinite(offset) && offset > 0 ? offset : null;
};
